import React from 'react';

const PageNotFound = () => {

    return (
        <div>
            <div className="wrapper">
                <h4>Page not found</h4>
            </div>
        </div>
    )
}
export default PageNotFound;


// WEBPACK FOOTER //
// ./src/components/pageNotFound/pageNotFound.js